const html = require('choo/html');
const assets = require('../../common/assets');
const modal = require('./modal');

module.exports = function(state, emit) {
  return html`
    <main class="main">
      <section
        class="relative flex flex-col items-center justify-center h-full w-full p-6 md:p-8 overflow-hidden md:rounded-xl md:shadow-big"
      >
        ${state.modal && modal(state, emit)}
        <h1 class="text-center text-3xl font-bold my-2">
          ${state.translate('expiredTitle')}
        </h1>
        <img src="${assets.get('notFound.svg')}" class="my-12 no-data" />
        <p class="max-w-md text-center text-grey-80 leading-normal">
          ${state.translate('trySendDescription')}
        </p>
        <p class="my-5">
          <a href="https://gis.vn/chia-se-tap-tin" class="btn rounded-lg flex items-center" role="button"
            >${state.translate('sendYourFilesLink')}</a
          >
        </p>
      </section>
    </main>
  `;
};
